import { ThemeUICSSObject } from '@apia/theme';
import apiaFinder from './apiaFinder';
import documents from './documents';
import documentsInfo from './documentsInfo';
import iframeOverlay from './iframeOverlay';
import jsp from './jsp';
import mainApp from './mainApp';
import documentUpload from './documentUpload';
import translation from './translation';
import buttonsBar from './buttonsBar';
import profiles from './profileFuncModal';
import usrFncTree from './usrFncTree';
import dateReasignment from './dateReasignment';
import taskListColumns from './taskListColumns';
import mainEnvironmentsSelector from './mainEnvironmentsSelector';
import about from './about';
import apiaFunctions from './apiaFunctions';
import apiaModal from './apiaModal';
import iframeModal from './iframeModal';
import gridEdition from './gridEdition';
import overlay from './overlay';
import confirm from './confirm';
import widgetSupervisionModal from './widgetSupervisionModal';
/* IMPORT HERE */

const modals: ThemeUICSSObject = {
  apiaFinder,
  dateReasignment,
  // TODO: remover confirm una vez se hayan pasado los componentes de NPM
  confirm,
  documents,
  documentsInfo,
  iframeModal,
  iframeOverlay,
  jsp,
  documentUpload,
  gridEdition,
  ...overlay,
  translation,
  buttonsBar,
  profiles,
  usrFncTree,
  taskListColumns,
  mainApp,
  mainEnvironmentsSelector,
  about,
  apiaFunctions,
  apiaModal,
  widgetSupervisionModal,
  /* PREPEND HERE */
};

export default modals;
